import ClientAPI from '../api/clients';

export const client = {
    state: {
        clientId: 0,
        client: null,
        clientLoadStatus: 0,
        clientUpdateStatus: 0
    },

    actions: {
        loadClient({commit, state}, params) {
            return new Promise((resolve, reject) => {
                commit('setClientLoadStatus', 1);

                if (params.user && Object.keys(params.user).length != 0) {
                    var func2 = ClientAPI.getClientWithSubscription;
                    var log = 'Client with Subscription';
                } else {
                    var func2 = ClientAPI.getClient;
                    var log = 'Client without Subscription';
                }

                func2(params.oauthClientId)
                    .then(function (response) {
                        console.log(log + ' Loaded');
                        commit('setClient', response.data.data);
                        commit('setClientLoadStatus', 2);

                        return resolve(response.data.data);
                    })
                    .catch(function () {
                        console.log(log + ' NOT Loaded');
                        commit('setClient', null);
                        commit('setClientLoadStatus', 3);

                        return resolve();
                    });
            })
        }
    },

    mutations: {
        setClientLoadStatus(state, status) {
            state.clientLoadStatus = status;
        },

        setClient(state, client) {
            state.client = client;
        }
    },

    getters: {
        getClientLoadStatus(state) {
            return state.clientLoadStatus;
        },

        getClient(state) {
            return state.client;
        }
    }
}
